import { render, staticRenderFns } from "./TicketDetailsButtons.vue?vue&type=template&id=dcecb88e&"
import script from "./TicketDetailsButtons.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports